import { NavLink, Outlet } from "react-router-dom";
import { Package, MapPin, User, FileText } from "lucide-react";

const TABS = [
  { to: "/conta/pedidos", label: "Pedidos", icon: Package },
  { to: "/conta/enderecos", label: "Endereços", icon: MapPin },
  { to: "/conta/dados", label: "Meus dados", icon: User },
  { to: "/conta/notas", label: "Notas fiscais", icon: FileText },
];

export default function AccountLayout() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-10">
      <h1 className="font-heading text-2xl font-semibold text-slate-900 mb-6">Minha conta</h1>
      <div className="flex gap-2 border-b border-slate-200 mb-8 overflow-x-auto">
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} data-testid={`account-tab-${t.to.split("/").pop()}`}
            className={({ isActive }) => `flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px whitespace-nowrap ${isActive ? "border-brand-600 text-brand-700" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
            <t.icon size={15} />{t.label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
